import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import CampaignFilterCriteria from './CampaignFilterCriteria'
import CampaignList from './CampaignList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './CampaignAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setCampaignDashboardCampaignList } from '../../store/slice/ManufSlice';

export default function CampaignListView({setShowEdit,setCampaignId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.campaignDashboard);   

    const [filteredCampaignList, setFilteredCampaignList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { campaignDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (campaignDashboard.campaignList.length>-1){
        setFilteredCampaignList(campaignDashboard.campaignList);
        transformToCardFormat(campaignDashboard.campaignList, setCardList);
      }
    },[campaignDashboard.campaignList])

    useEffect(()=>{
          transformToCardFormat(filteredCampaignList, setCardList);
      },[filteredCampaignList])

    useEffect(()=>{
        if (filterCriteria.audienceid==='' && filterCriteria.audiencename==='' && filterCriteria.audienceemail==='' && filterCriteria.templateid==='' && filterCriteria.templatename==='' ){
            setFilteredCampaignList(campaignDashboard.campaignList);
            transformToCardFormat(campaignDashboard.campaignList, setCardList);

        } else {
            setFilteredCampaignList(
                campaignDashboard.campaignList
                    .filter(campaign=> campaign.audienceemail.toString().toUpperCase().includes(filterCriteria.audienceemail.toString().toUpperCase()))
.filter(campaign=> campaign.templatename.toString().toUpperCase().includes(filterCriteria.templatename.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(campaignDashboard.filteredCampaignList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <CampaignList
                    setShowEdit={setShowEdit}
                    setCampaignId = {setCampaignId}
                    tableList={filteredCampaignList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}